// data
import diseases from './repo/diseases';
import reviews from './repo/reviews';

// navigation
import Anchor from './navigation/anchor';
import Route from './navigation/route';
import router from './navigation/router';

// components
import Authenticator from './components/authenticator/index';
import ProtectedContent from './components/authenticator/protected-content';
import EditDiseaseForm from './components/disease/edit';
import Disease from './components/disease/index';
import graph from './components/social/open-graph';

// style
import "./index.css";

import template from './index.tpl';
import Search from "./components/search";

const global = window || {};

export default DomClass(template, async function Index() {
	const _t = this;

	this.repo = {
		diseases: diseases,
		reviews: reviews
	};
	
	this.show = function(content) {
		this.content = content || "Content not found.";
		graph.set(this.content);
	};

	this.showDisease = async function(normalizedName) {
		this.show(new Disease(
			await diseases.get(decodeURIComponent(normalizedName))
		));
	};

	const route = new Route([
		/^disease\/([^\/]*)$/, (name) => _t.showDisease(name),
		/^search\/q=([^\/]*)(\/a=([^\/]*))?$/, (query, _, _after) => {
			_t.show(new Search({
				query: decodeURIComponent(query),
				get_after: _after ? decodeURIComponent(_after) : null
			}));
		},
		/^edit$/, () => _t.show(new ProtectedContent({
			content: () => new EditDiseaseForm(),
			error: "You must be signed in to add or edit diseases!"
		})),
		/^edit\/([^\/]*)/, (name) => _t.show(new ProtectedContent({
			content: () => new EditDiseaseForm({
				name: decodeURIComponent(name)
			}),
			error: "You must be signed in to add or edit diseases!"
		})),
		/^$/, () => _t.show(new Search()),
		/^.+$/, () => route.navigate(''),
	]);

	global.App = this;

});
